import { Controller } from "@hotwired/stimulus"

// "Select In-house" on the new reservation picker: ticks every member carrying the
// tag. Additive, so In-house then Seniors selects both; Clear unticks everyone.
export default class extends Controller {
  static targets = ["checkbox"]

  select({ params: { id } }) {
    this.checkboxTargets.forEach((checkbox) => {
      if (this.tagIds(checkbox).includes(id)) checkbox.checked = true
    })
  }

  clear() {
    this.checkboxTargets.forEach((checkbox) => { checkbox.checked = false })
  }

  tagIds(checkbox) {
    return (checkbox.dataset.tagIds || "").split(" ").filter(Boolean).map(Number)
  }
}
